import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle } from 'recompose';
import PropTypes from 'prop-types';

import { Field, reduxForm } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { loginRequest, loginReset } from '../../redux/reducers/login';

import { commonStyles } from '../../styles/styles';
import EmailField from './EmailField';
import PasswordField from './PasswordField';
import { validateLogin } from './validate'; 

const LoginForm = ({ classes, handleSubmit, submitting, handleSubmitLogin, loginReducer, isDeactivated }) => (
  <form onSubmit={handleSubmit(handleSubmitLogin)} className={classes.form}>
    {loginReducer.error && <Typography className={classes.formError}>{loginReducer.error}</Typography>}
    {isDeactivated && <Typography className={classes.formError}>You account has been successfully deactivated</Typography>}
    <Field name="Email" component={EmailField} />
    <Field name="Password" component={PasswordField} id={Date.now().toString()} label="Password" />
    <Button
      variant="contained"
      type="submit"
      disabled={submitting}
      className={`${classes.defaultButton} ${classes.shortButton}`}
    >
      LOGIN
    </Button>
  </form>
);

LoginForm.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  handleSubmitLogin: PropTypes.func,
  login: PropTypes.instanceOf(Object),
};

const mapStateToProps = state => ({
  formState: state.form,
  loginReducer: state.loginReducer,
});
const mapDispatchToProps = dispatch => ({
  loginRequest: () => dispatch(loginRequest()),
  loginReset: () => dispatch(loginReset()),
});

const styles = () => ({
  ...commonStyles,
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 10,
   
  },
});

export default compose(
  reduxForm({
    form: 'login',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    handleSubmitLogin: props => values => {
      props.loginReset();
      validateLogin(values);
      props.loginRequest();
    },
  }),
  lifecycle({
    componentWillUnmount() {
      if (this.props.login.error) {
        this.props.loginReset();
      }
    },
  }),
  withStyles(styles),
)(LoginForm);



// WEBPACK FOOTER //
// ./src/Components/Form/LoginForm.jsx